module.exports = __webpack_public_path__ + "static/media/facebook.958a495b.png";